import { useMemo } from 'react';
import {
  useGetReservationsListQuery,
  useGetReservationsFilterSelectsQuery,
} from '../Service/extendedReservationsApi';
import { ReservationSearchFilters } from '../Types/reservationTypes';

export function useReservationsData(
  filters: ReservationSearchFilters,
  page: number,
  rowsPerPage: number
) {
  const memoizedFilters = useMemo(
    () => ({
      createdAt: filters.createdAt || '',
      source: filters.source || '',
      offerId: filters.offerId ? parseInt(filters.offerId) : undefined,
      applicantFirstName: filters.applicantFirstName || '',
      applicantLastName: filters.applicantLastName || '',
      applicantEmail: filters.applicantEmail || '',
      pageNumber: page + 1,
      pageSize: rowsPerPage,
    }),
    [filters, page, rowsPerPage]
  );

  const {
    data: reservationsData,
    isLoading: isReservationsLoading,
    isError: isReservationsError,
    error: reservationsError,
  } = useGetReservationsListQuery(memoizedFilters, {
    // Refetch data when component mounts or filters change
    // to ensure fresh data after updates (e.g., payment changes)
    refetchOnMountOrArgChange: true,
  });

  const {
    data: filterSelects,
    isLoading: isFilterSelectsLoading,
    isError: isFilterSelectsError,
    error: filterSelectsError,
  } = useGetReservationsFilterSelectsQuery();

  return {
    reservationsData,
    isReservationsLoading,
    isReservationsError,
    reservationsError,
    filterSelects,
    isFilterSelectsLoading,
    isFilterSelectsError,
    filterSelectsError,
  };
}
